export function useImpersonate() {
  const impersonateStore = useImpersonateStore()

  const removeImpersonate = () => {
    impersonateStore.deleteImpersonate()
  }

  const checkIsImpersonate = () => {
    const isImpersonated = impersonateStore.verifyIsImpersonated()

    if (isImpersonated)
      return isImpersonated

    const partnerToImpersonate
      = impersonateStore.isImpersonated() as { partnerId: number, fantasyName: string, registrationType?: string } | null

    // The registration type is saved empty when the partner query fails (e.g. a partner without `sfplus`),
    // and the layout reads it from the partner query anyway, so only the partner identity is required.
    if (partnerToImpersonate?.partnerId && partnerToImpersonate.fantasyName) {
      impersonateStore.createImpersonate({ ...partnerToImpersonate, registrationType: partnerToImpersonate.registrationType ?? '' })

      return true
    }

    return false
  }

  return {
    checkIsImpersonate,
    removeImpersonate,
  }
}
